import React, { useState, useEffect } from "react";
import axios from "axios";
import { Loading } from "../Other/Loading";

const TrustedBanner = () => {
  const [trustedData, setTrustedData] = useState(null);
  const [statsData, setStatsData] = useState(null);
  const [quoteData, setQuoteData] = useState(null);

  useEffect(() => {
    async function fetchBusinessData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("AAAAAAAAAPI Response:", events);
        setTrustedData(events.trustedBy);
        console.log("Trusted Data:", events.trustedBy);
        setStatsData(events.stats);
        console.log("Trusted Data:", events.stats);
        setQuoteData(events.quote);  // turns string into array of objects
        console.log("Trusted Data:", events.quote);
      }
      catch (error) {
        console.error("Error fetching business data:", error);
      }
    }
    fetchBusinessData();
  }, []);



  if (!trustedData || !statsData || !quoteData)
    return <p className="text-center text-gray-600"><Loading /></p>;

  return (
    <section className="py-6 px-4 md:px-16 text-center">


      {/* Stats and Quote Section */}
      <div className="  px-6 md:px-16 py-12 mt-8">
        <div className="flex flex-col md:flex-row items-center gap-6 mt-6">
          {/* Left: Statistics Section */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-bold text-left mb-4">{statsData.title}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              {statsData.items.map((stat, index) => (
                <div key={index} className="flex items-center gap-4">
                  {/* Icon Wrapper (Circle) */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#4d4f4d]">
                    {/* <img src={`${process.env.REACT_APP_COURSE_API_BASEURL}${stat.icon}`} alt="Stat Icon" className="w-10 h-10 object-contain" /> */}
                    <img src={stat.icon} alt="Stat Icon" className="w-10 h-10 object-contain" />
                  </div>
                  {/* Text Section */}
                  <div>
                    <p className="text-yellow-400 font-bold text-xl md:text-2xl text-left">{stat.value}</p>
                    <p className=" text-sm md:text-base text-left">{stat.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Quote Section */}
          <div className="bg-[#4d4f4d] text-white p-6 rounded-lg w-full md:w-[35%]">
            <p className="text-5xl md:text-6xl font-bold mb-3">❝</p>
            <p className="italic text-lg md:text-xl">{quoteData.text}</p>
            <div className="bg-white text-black px-3 py-2 rounded mt-4 w-full">
              <p className="text-lg md:text-xl font-semibold">{quoteData.author}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBanner;
